import { render, staticRenderFns } from "./orgEditDialog.vue?vue&type=template&id=275fdaf6&scoped=true&"
import script from "./orgEditDialog.vue?vue&type=script&lang=js&"
export * from "./orgEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./orgEditDialog.vue?vue&type=style&index=0&id=275fdaf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275fdaf6",
  null
  
)

export default component.exports